<template>
	<div class="news-trending-item">
		<div class="news-trending-item__wrapper">
			<h3 class="news-trending-item__header">
				<span class="news-trending-item__title">{{ $helpers.nameService[id] }}</span>
				<span class="news-trending-item__time">{{ timeFrame }}</span>
			</h3>
			<ul
				class="news-trending-item__body"
				ref="trendingList"
			>
				<li
					v-for="(listEl, index) in item"
					:key="listEl.id"
					class="news-trending-item__body-item"
				>

					<div class="news-trending-item__body-item_id">
						{{ index + 1 }}
					</div>

					<div class="news-trending-item__body-item_change-rate">
						<svg v-if="listEl?.change_place > 0" class="news-trending-item__body-item_change-rate-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 12 12" fill="none">
							<path d="M9 7.5L6 4.5L3 7.5" stroke="#02FF49" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<svg v-if="listEl?.change_place < 0" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 12 12" fill="none">
							<path d="M3 4.5L6 7.5L9 4.5" stroke="#E71919" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<span v-if="listEl?.change_place">
							{{ Math.abs(listEl.change_place) }}
						</span>
					</div>

					<NuxtLink :to="type === 'tag' ? `/news/t/${listEl.slug}/` : `/news/${listEl.slug}/`" class="news-trending-item__body-item_title link link_color_white">
						{{ listEl.name }}
					</NuxtLink>

					<div class="news-trending-item__body-item_count">
						{{ $helpers.formatFollowers(listEl.news_count) }}
					</div>
				</li>

			</ul>
			<div
				class="news-trending-item__footer"
				:class="{ 'news-trending-item__footer_items-less-than-five': !isItemLengthMoreThanFive }"
			>
				<span
					v-if="isItemLengthMoreThanFive"
					class="news-trending-item__link"
					@click="toggleDisplay"
				>
					{{ buttonText }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'NewsTrendingItem',
	props: {
		id: {
			type: String,
			required: true
		},
		timeFrame: {
			type: String,
			required: true
		},
		item: {
			type: Object,
			required: true
		},
		type: {
			type: String,
			default: 'tag'
		}
	},
	data() {
		return {
			mode: 'expanded'
		}
	},
	computed: {
		maxHeightForExpanded() {
			let totalHeight = 0;
			const children = this.$refs.trendingList.children;
			for (let i = 0; i < this.$refs.trendingList.children.length; i++) {
				totalHeight += children[i].clientHeight + 10; // 10px - gap
			}
			return totalHeight;
		},
		maxHeightForContracted() {
			let totalHeight = 0;
			const children = this.$refs.trendingList.children;
			for (let i = 0; i < Math.min(children.length, 5); i++) {
				totalHeight += children[i].clientHeight + 10; // 10px - gap
			}
			return totalHeight;
		},
		buttonText() {
			return this.mode === 'expanded' ? 'Show All' : 'Show Less';
		},
		isItemLengthMoreThanFive() {
			return this.item.length > 5;
		}
	},
	mounted() {
		this.$nextTick(() => {
			if (this.$refs.trendingList) {
				this.$refs.trendingList.style.maxHeight = `${this.maxHeightForContracted}px`;
			}
		});
	},
	methods: {
		toggleDisplay() {
			if (this.mode === 'expanded') {
				this.$refs.trendingList.style.maxHeight = `${this.maxHeightForExpanded}px`;
				this.mode = 'contracted';
			} else {
				this.$refs.trendingList.style.maxHeight = `${this.maxHeightForContracted}px`;
				this.mode = 'expanded';
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.news-trending-item {
	box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
	background: #1C2B3B;
	border: 1px solid #344859;
	margin-bottom: 15px;
	break-inside: avoid;

	&__wrapper {
		display: flex;
		flex-direction: column;
	}

	&__header {
		display: flex;
		justify-content: space-between;
		align-items: baseline;
		font-weight: 500;
		border-bottom: 1px solid #344859;
		padding: 13px 20px;
	}

	&__title {
		font-size: 18px;
		font-weight: 600;
	}

	&__time {
		font-size: 14px;
	}

	&__body {
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: 10px 20px 0;
		overflow: hidden;
		//max-height: 260px;
		transition: max-height 0.3s ease-out;
	}

	&__body-item {
		display: grid;
		align-items: center;
		grid-template-columns: 12px 35px auto 35px;
		gap: 10px;
		font-weight: 500;

		&_change-rate {
			display: flex;
			align-items: center;
			gap: 2px;
			font-size: 11px;

			span {
				opacity: 0.5;
			}
		}

		&_title {
			padding: 3px 0;
			word-break: break-word;
		}

		&_count {
			margin-left: auto;
			color: $neutrals3;
		}
	}

	&__footer {
		display: flex;
		padding: 10px 20px 20px;

		&_items-less-than-five {
			padding: 0px 20px 20px;
		}
	}

	&__link {
		font-size: 12px;
		font-weight: 500;
		color: #fff;
		text-decoration: underline;
		cursor: pointer;
	}
}</style>
